import React from "react";
import "./BasicChat.css";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../statemanagement/StateProvider";
import "./BasicChat.css"; //should be moved to Header.css
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Button } from "@mui/material";

//AuthWrapperHook should also be pushed here
const Header = ({showLine = true, showLogin = false}) => {
    const [{ user }, _] = useStateValue(); //header will always have access to the user object from state
    const navigate = useNavigate(); //navigation to other pages within the SPA

    return (<div className="container_header">
        <div className="container_header_banner" style={{ justifyContent: "space-between" }}>
            <div style={{ display: "flex" }} onClick={_ => navigate("/")}>
                <AllInclusiveIcon style={{ width: "35px", height: "35px" }} />
                <h1 style={{ fontSize: "30px", fontWeight: 500, marginLeft: "2%", opacity: "0.9", display: "flex" }}>BharatChat.ai</h1>
            </div>
            {!user && showLogin && <Button style={{ fontSize: "0.74em", textTransform: "inherit", background: "black", opacity: "0.8", borderRadius: "18px" }} variant="contained" onClick={_ => navigate("/login")}>Login</Button>}
            {!!user && <AccountCircleIcon style={{ fontSize: "xx-large" }} onClick={_ => navigate("/login")} />}
        </div>
        {showLine && <hr style={{ border: "none", height: "1px", background: "rgba(128, 128, 128, 0.2)" }} />}
    </div>);
}

export default Header;



// const Header = (showLine = true) => {

//     const navigate = useNavigate();

//     return (<div className="container_header">
//         <div className="container_header_banner" style={{ justifyContent: "space-between" }}>
//             <div style={{ display: "flex" }} onClick={_ => navigate("/")}>
//                 <AllInclusiveIcon style={{ width: "35px", height: "35px" }} />
//                 <h1 style={{ fontWeight: 500, marginLeft: "2%", opacity: "0.9", display: "flex" }}>ChatDragon.ai</h1>
//             </div>
//         </div>
//         {showLine && <hr style={{ border: "none", height: "1px", background: "rgba(128, 128, 128, 0.2)" }} />}
//     </div>);
// }

// export default Header;